__turbopack_export_value__({
  "backPanel": "intro-overlay-module____-AGa__backPanel",
  "crest": "intro-overlay-module____-AGa__crest",
  "envelope": "intro-overlay-module____-AGa__envelope",
  "envelope-float": "intro-overlay-module____-AGa__envelope-float",
  "envelope-shadow": "intro-overlay-module____-AGa__envelope-shadow",
  "flap": "intro-overlay-module____-AGa__flap",
  "foldBottom": "intro-overlay-module____-AGa__foldBottom",
  "foldLeft": "intro-overlay-module____-AGa__foldLeft",
  "foldRight": "intro-overlay-module____-AGa__foldRight",
  "glow": "intro-overlay-module____-AGa__glow",
  "hint": "intro-overlay-module____-AGa__hint",
  "isClosing": "intro-overlay-module____-AGa__isClosing",
  "isOpen": "intro-overlay-module____-AGa__isOpen",
  "letter": "intro-overlay-module____-AGa__letter",
  "letterInner": "intro-overlay-module____-AGa__letterInner",
  "line": "intro-overlay-module____-AGa__line",
  "lineShort": "intro-overlay-module____-AGa__lineShort",
  "monogram": "intro-overlay-module____-AGa__monogram",
  "overlay": "intro-overlay-module____-AGa__overlay",
  "scene": "intro-overlay-module____-AGa__scene",
  "seal": "intro-overlay-module____-AGa__seal",
  "shadow": "intro-overlay-module____-AGa__shadow",
  "shimmer-sweep": "intro-overlay-module____-AGa__shimmer-sweep",
  "spark": "intro-overlay-module____-AGa__spark",
});
